import React, { useState, useEffect, useCallback} from "react";

///Styles
import { toast } from "react-toastify";
import { ContainerLoading, Container, Content, Table, Bar, BarContainer, ValueContainer, Button } from "./styles";

///Components
import { SpaceLoader } from "../../../loaders/spaceLoader";
import { formatMoney } from '../../../../Utils/formatMoney';
import { ButtonExportExcel } from "../buttonExportExcel";


///Services
import { api } from "../../../../services/api";
import { useAdministrativeContext } from "../../../../pages/administrativePanel/administrativePanelContext";
import { download_csv } from "../centralizedModal/JsonToCsv";
import { FormatMoney } from "../formatMoney";

export function CurveAbcProducts() {
    const {
        startDate,
        endDate,
        listBusinessToFilter,
    } = useAdministrativeContext();

    const [productsAll, setProductsAll] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [loadingButton, setLoadingButton] = useState(false);
    const [openButtonExcel, setOpenButtonExcel] = useState(false);

    const handleNewProducts = useCallback(async () => {
        setLoadingButton(true);
        try {
            const response = await api.post(`/getCurveAbcProducts/?page=${page}`, {
                startDate: startDate,
                endDate: endDate,
                business: listBusinessToFilter
            })
            const { products, next_page } = response.data;
            setProductsAll([...productsAll, ...products]);
            setPage(next_page);
            setLoadingButton(false);

        } catch (error) {
            toast.error('Ops, algo deu errado.');
            setLoadingButton(false);
        }

  
    }, [endDate, listBusinessToFilter, page, startDate, productsAll])


    useEffect(() => {
        async function loadProducts() {
            setLoading(true)

            try{
                const response = await api.post('/getCurveAbcProducts/?page=1', {
                    startDate: startDate,
                    endDate: endDate,
                    business: listBusinessToFilter
                })

                const { products, next_page } = response.data;
                setProductsAll(products);
                setPage(next_page);
                setLoading(false)
            }
            catch(error){
                toast.error('Ops, algo deu errado.');
            }
        }
        loadProducts()
    }, [endDate, listBusinessToFilter, startDate]);

    async function handleDownloadCSV() {
        setLoading(true);
        await api.post('/getCurveAbcProducts/?page=0', {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter
        })
            .then((response) => {
                //console.log(response)
                if (response.data.sucess === 0) {
                    toast.error(response.data.message)
                    return
                }

                const { products } = response.data;

                const newArr = products.map((item) => {
                    return ({
                        Id: item.idProduto,
                        Produto: item.produto,
                        Preco: Number(item.preco).toFixed(2),
                        Quantidade: item.quant,
                        Preco_Final: Number(item.precoFinal).toFixed(2),
                        Porcentagem: Number(item.perc).toFixed(2),
                        Porcentagem_Acumulada: Number(item.percAcumulado).toFixed(2)
                    })
                });

                download_csv(newArr, 'Curva Abc dos Produtos');
                setOpenButtonExcel(false)
            })
        setLoading(false);
    }

    if (loading) {
        return (
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return (
        <Container>
            <Content>
                <ButtonExportExcel
                    open={openButtonExcel}
                    setOpen={setOpenButtonExcel}
                    handleDownloadCSV={handleDownloadCSV}
                />
                
                
                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Produto</th>
                            <th>Preço</th>
                            <th>Quantidade</th>
                            <th>Preço Final</th>
                            <th>Percentual</th>
                            <th>Percentual Acumulado</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            productsAll.map((item,index) => {
                                return (
                                    <tr key={index}>
                                        <td className={item.classificacao}>{item.classificacao}</td>
                                        <td>{item.produto}</td>
                                        <td>{formatMoney(item.preco)}</td>
                                        <td>{item.quant}</td>
                                        <td>
                                            <FormatMoney value={item.precoFinal} />
                                        </td>
                                        <td>
                                            <BarContainer>
                                                    <Bar percent={item.perc}>
                                                        {
                                                            (item.perc) >= 70 &&
                                                                Number(item.perc).toFixed(2)+'%'
                                                        }
                                                    </Bar>

                                                    {
                                                        (item.perc) < 70 ?
                                                            Number(item.perc).toFixed(2)+'%'
                                                            :
                                                            <></>
                                                    }
                                            </BarContainer>


                                            <ValueContainer>
                                                {Number(item.perc).toFixed(2)+'%'}
                                            </ValueContainer>
                                        </td>
                                        <td>{Number(item.percAcumulado).toFixed(2)}%</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>


                {
                    page !== null &&
                    <Button onClick={handleNewProducts}>
                        {
                            loadingButton ?
                                '...aguarde'
                                :
                                'Ver mais'
                        }
                    </Button>
                }
            </Content>
        </Container>
    )
}